<template>
  <b-container fluid class="h-100-trim-header-footer" id="tailieWidget">
    <b-row>
      <b-col md="12" id="tailie-forgot-password">
        <div id="tailie-password">
          <p class="tailieTitle">{{ $t("password-reset-main-title") }}</p>
          <p class="tailieSubTitle">{{ $t("password-reset-sub-title") }}</p>
          <b-form @submit="onSubmit">
            <b-form-group
              id="label-password"
              :label="$t('password')"
              label-for="input-password"
              label-class="tailie-input-label"
              label-id="tailiePasswordLabel"
            >
              <b-form-input
                id="input-password"
                class="tailie-input"
                v-model="form.password"
                type="password"
                required
              />
            </b-form-group>
            <b-form-group
              id="label-password-repeat"
              :label="$t('password-reset-repeat-password')"
              label-for="input-password"
              label-class="tailie-input-label"
              label-id="tailiePasswordLabel"
            >
              <b-form-input
                id="input-password-repeat"
                class="tailie-input"
                v-model="form.passwordRepeat"
                type="password"
                required
              />
            </b-form-group>
            <b-button
              type="submit"
              :disabled="!valid"
              variant="primary"
              class="tailie-tab tailieBluebutton tailieSendEmailPassword margin-top-15"
            >
              {{ $t("confirm") }}
            </b-button>
            <p id="message">
              {{ message }}
            </p>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "pages-password-reset-password",
  data() {
    return {
      form: {
        password: "",
        passwordRepeat: ""
      },
      message: "",
      valid: false
    };
  },
  watch: {
    form: {
      deep: true,
      handler(n) {
        let message = "";
        this.valid = false;
        if (n.password.length < 7) {
          message = this.$t("password-reset-too-short");
        } else if (n.password !== n.passwordRepeat) {
          message = this.$t("password-reset-no-match");
        }
        this.message = message;
        if (message.length === 0) {
          this.valid = true;
        }
      }
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$store.commit("ui/SET_LOADING_TEXT", "Resetting password!");
      this.$store.commit("ui/SET_LOADING", true);
      this.$store
        .dispatch("users/passwordReset", this.form.password)
        .then(() => {
          this.$store.commit("ui/SET_LOADING", false);
          this.$router.push({ name: "login" });
        })
        .catch(() => this.$store.commit("ui/SET_LOADING", false));
    }
  }
};
</script>

<style scoped>
.btn-link.btn-black {
  padding: 0.375rem 0.75rem !important;
}

.label,
label {
  color: #232323;
  text-align: right;
  font-size: 0.875rem;
}

#message {
  color: rgb(220, 53, 69);
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  margin-top: 20px;
}
</style>
